import { Check, Clock3, Leaf, ShieldCheck, Sparkles } from "lucide-react";
import Reveal from "@/components/Reveal";
import { premierReasons } from "@/data/siteData";

const icons = [ShieldCheck, Leaf, Clock3, Sparkles, Check];

export default function PrinciplesSection() {
  return (
    <section className="values-section" id="standard" data-testid="premier-standard-section">
      <div className="section-shell values-grid">
        <Reveal className="values-intro" delay={80}>
          <div className="eyebrow"><span className="eyebrow__dot" /> 01 / What makes us premier</div>
          <h2>Cleanliness, <em>elevated.</em></h2>
          <p>There is a difference between a space that is clean and one that feels completely cared for. We live in that difference.</p>
          <span className="values-stamp">SXM / B.V.</span>
        </Reveal>
        <div className="values-list">
          {premierReasons.map((reason, index) => {
            const Icon = icons[index];
            return <Reveal as="article" className="value-item" delay={130 + index * 80} key={reason.number} data-testid={`premier-value-${reason.number}`}>
              <span className="value-item__number">{reason.number}</span>
              <div className="value-item__copy"><div className="value-item__title"><Icon size={16} /> {reason.title}</div><p>{reason.text}</p></div>
            </Reveal>;
          })}
        </div>
      </div>
    </section>
  );
}
